import dataProvider from "./dataProvider";
import { FormDataLogin } from "./dataProvider";

const authProvider = {
    login: async ({username, password}: FormDataLogin) => {
        try{
            await dataProvider.login({username,password});
            return Promise.resolve();
        }
        catch(error: any){
            return Promise.reject(error);
        }
    },
    logout: async () => {
        try{
            await dataProvider.logout();
            return Promise.resolve();
        }
        catch(error: any) {
            return Promise.reject(error);
        }
    },
    checkAuth: async () => {
        try {
          await dataProvider.checkAuth();
          return Promise.resolve();
        } catch (error) {
          return Promise.reject(error);
        }
      },
    
    checkError: (error: any) => dataProvider.checkError(error),
    
    getPermissions: () => Promise.resolve(),
}

export default authProvider;
